import React from "react";
import { Dialog, DialogProps } from "@mui/material";

export const Popup: React.FC<DialogProps> = ({ children, ...props }) => {
  return <Dialog {...props}>{children}</Dialog>;
};
